import React, { useState } from "react";
import "./UnderwritingChoicePopup.scss";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";

interface UnderwritingNumberInputPopupProps {
  visible: boolean;
  title: string;
  placeholder: string;
  onSubmit: (value: number) => void;
}

export const UnderwritingNumberInputPopup: React.FC<UnderwritingNumberInputPopupProps> = ({
  visible,
  title,
  placeholder,
  onSubmit,
}) => {
  const [value, setValue] = useState<string>("");
  useOverlayPopupOpen(visible);

  if (!visible) return null;

  const handleSubmit = () => {
    const num = parseInt(value, 10);
    if (!isNaN(num) && num >= 0) {
      onSubmit(num);
      setValue("");
    }
  };

  const disabled = value.trim() === "" || isNaN(parseInt(value, 10)) || parseInt(value, 10) < 0;

  return (
    <div className="underwriting-popup-overlay">
      <div className="card-width underwriting-popup-card">
        <h3 className="underwriting-popup-title">{title}</h3>
        <input
          type="number"
          min={0}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          className="underwriting-popup-input"
        />
        <button
          onClick={handleSubmit}
          disabled={disabled}
          className="underwriting-popup-submit"
        >
          تأكيد
        </button>
      </div>
    </div>
  );
};
